import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { projectFirestore } from "../../../firebase/config";
import { Table, Col, Row, Container } from "react-bootstrap";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { useLocation } from "react-router-dom";
import {
  onSnapshot,
  collection,
  query,
  where,
  doc,
  getDoc,
} from "firebase/firestore";
import "./VentasXDias.css";

export default function VentasXEmpleado() {
  const location = useLocation();
  const { register } = useAuthContext();
  const [data, setData] = useState([]);
  const [dataChart, setDataChart] = useState([]);
  const [hide, setHide] = useState("");
  const [fechaInicial, setFechaInicial] = useState(
    new Date().getFullYear() + "-01-01"
  );
  const [fechaFinal, setFechaFinal] = useState(
    new Date().toISOString().substring(0, 10)
  );

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp.seconds * 1000); // Multiplica por 1000 para convertir los segundos a milisegundos
    const formattedDate = date.toLocaleDateString(); // Formatea la fecha como una cadena legible
    const formattedTime = date.toLocaleTimeString(); // Obtiene la hora como una cadena legible
    return {
      date: formattedDate, // Retorna la fecha formateada
      time: formattedTime, // Retorna la hora formateada
    };
  };

  const handleFechaInicial = (e) => {
    setFechaInicial(e.target.value);
  };

  const handleFechaFinal = (e) => {
    setFechaFinal(e.target.value);
  };

  const HiddenTable = () => {
    if (hide === "hidden") {
      setHide("");
      let elem = document.getElementById("ex-tblChecador");
      elem.hidden = true;
    } else {
      setHide("hidden");
      let elem = document.getElementById("ex-tblChecador");
      elem.removeAttribute("hidden");
    }
  };

  useEffect(() => {
    const Listener = async () => {
      const fechaI = Date.parse(fechaInicial);
      const fi = new Date(fechaI);
      const fechaF = Date.parse(fechaFinal);
      const ff = new Date(fechaF);
      const filtros = [
        { campo: "puesto", operador: "==", valor: register.id },
        { campo: "status", operador: "==", valor: "COMPLETADO" },
        { campo: "fecha", operador: ">=", valor: fi },
        { campo: "fecha", operador: "<=", valor: ff },
      ];
      let q = query(collection(projectFirestore, "turnero"));
      filtros.forEach((filtro) => {
        const { campo, operador, valor } = filtro;
        q = query(q, where(campo, operador, valor));
      });
      let datoschart = [];
      await onSnapshot(q, async (docs) => {
        const documentosColeccion = [];
        await docs.docs.forEach(async (docss) => {
          const data = docss.data();
          data.id = docss.id;
          if (data.atendio !== "Administrador" && data.atendio) {
            let que = await doc(projectFirestore, "users", data.atendio);
            let hsd = getDoc(que);
            data.atendio = (await hsd).data().fullName;
            documentosColeccion.push(data);
          } else {
            documentosColeccion.push(data);
          }
          datoschart = [];
          const result = Object.groupBy(
            documentosColeccion,
            ({ atendio }) => atendio
          );
          for (const [key, value] of Object.entries(result)) {
            let Nombre = key;
            if (Nombre === "undefined") {
              Nombre = "Prueba";
            }
            let sum = 0;
            value.forEach((elemen) => {
              sum += elemen.total;
            });
            datoschart.push({ label: Nombre, value: sum });
            setDataChart(datoschart);
          }
        });
        setDataChart(datoschart);
        setData(documentosColeccion);
      });
    };
    Listener();
  }, [fechaFinal, fechaInicial, register.id]);

  return (
    <div>
      <h1>{location.state.Name}</h1>
      <br />
      <br />
      <Container>
        <Row>
          <Col md={3} className="">
            <h4 className="center">Rango de fechas</h4>
            <Row style={{ margin: "unset !important" }}>
              <br />
              <div className="form-switch">
                <label className="lblFiltro"> Fecha inicial</label>
                <input
                  className="form-date"
                  type="date"
                  value={fechaInicial}
                  onChange={handleFechaInicial}
                  name="fechaInicial"
                  id="flexSwitchCheckDefault"
                />
              </div>
              <div className="form-switch">
                <label className="lblFiltro"> Fecha inicial</label>
                <input
                  className="form-date"
                  type="date"
                  value={fechaFinal}
                  onChange={handleFechaFinal}
                  name="fechaFinal"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
          </Col>
          <Col md={2}></Col>
          <Col md={4}>
            <PieChart
              series={[
                {
                  arcLabel: (item) => `${item.value}`,
                  arcLabelMinAngle: 30,
                  highlightScope: { faded: "global", highlighted: "item" },
                  faded: {
                    innerRadius: 30,
                    additionalRadius: -30,
                    color: "gray",
                  },
                  data: dataChart,
                },
              ]}
              sx={{
                [`& .${pieArcLabelClasses.root}`]: {
                  fill: "white",
                  fontWeight: "bold",
                  fontSize: "20px",
                },
              }}
              width={620}
              height={350}
            />
          </Col>
          <Col md={1} className=""></Col>
        </Row>
      </Container>
      <Container>
        <Col md={4}>
          <div className="form-switch">
            <label className="lblFiltro">Visualizar datos en tabla</label>
            <input
              className="form-check-input"
              type="checkbox"
              checked={hide}
              onChange={HiddenTable}
              name="hide"
              id="flexSwitchCheckDefault"
            />
          </div>
        </Col>
        <Table striped bordered hover hidden border="2" id="ex-tblChecador">
          <thead>
            <tr>
              <th>Atendio</th>
              <th>Fecha</th>
              <th>Tipo de pago</th>
              <th>Total</th>
              <th>Cliente</th>
            </tr>
          </thead>
          <tbody>
            {data.sort().map((val, key) => {
              const { date, time } = formatTimestamp(val.fecha);
              return (
                <>
                  <tr key={key}>
                    <td>{val.atendio}</td>
                    <td>
                      {date} {time}
                    </td>
                    <td>{val.tipo_pago}</td>
                    <td>$ {val.total}</td>
                    <td>{val.user_name}</td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </Table>
      </Container>
    </div>
  );
}
